export default __webpack_public_path__ + "34bbda2f13b5b8e995330f30da23f118.svg";